import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { LeaveTypesPage } from "@/pages/dashboard/leave-types/list";

export const Route = createFileRoute("/_main/dashboard/leave-types/")({
  component: () => (
    <RequirePermission action="lookups.manage">
      <LeaveTypesPage />
    </RequirePermission>
  ),
});
